import { Modal } from 'antd';
import Button from '../Button';
import CloseIcon from '../icons/CloseIcon';
import WarningIcon from '../icons/WarningIcon';
import ErrorIcon from '../icons/ErrorIcon';
import Paragrapgh from '../Paragrapgh';
import Subtitle from '../Subtitle';
import Feedback from '../feedback/Feedback';
import { useWidth } from '../../../lib/useWidth';
import { useSelector } from 'react-redux';
import { selectLang } from '../../../store/ui/ui.selector';
import { translate } from '../../../lib/lang.helper';

interface Props {
  type: string;
  onCancel: () => void;
  onConfirm?: () => void;
  className?: string;
  hideCancelBtn?: boolean;
  text: string | React.ReactElement;
  title: string;
  visible: boolean;
  disabled?: boolean;
  buttonText?: string;
  warningText?: string;
}

const ModalComponent = ({
  visible,
  onCancel,
  onConfirm,
  hideCancelBtn,
  title,
  text,
  type,
  className,
  disabled,
  buttonText,
  warningText,
}: Props) => {
  const width = useWidth();
  const lang = useSelector(selectLang);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      className={className}
      footer={null}
      closable
      closeIcon={<CloseIcon />}
      width={600}
    >
      <div className='d-flex align-center mb-16'>
        {type === 'warning' && !warningText && (
          <WarningIcon className='mr-10' />
        )}
        {type === 'delete' && <ErrorIcon className='mr-10' />}
        <Subtitle color='black-1' align='left' size={1} fontWeight={600}>
          {translate(lang, title)}
        </Subtitle>
      </div>
      <Paragrapgh
        color='black'
        align='left'
        className='mb-16'
        size={2}
        fontWeight={400}
      >
        {text}
      </Paragrapgh>
      {warningText && (
        <Feedback
          isWithoutClosable
          isIcon
          theme='light'
          className='mb-24'
          message={warningText}
          type='warning'
        />
      )}
      <div className='modal-button d-flex justify-end align-center'>
        {type && !hideCancelBtn && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='transparent'
            color='blue'
            onClick={onCancel}
          >
            {translate(lang, 'Cancel')}
          </Button>
        )}
        {type === 'confirm' && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='fill'
            color='green'
            className='ml-16'
            onClick={onConfirm}
            disabled={disabled}
          >
            {typeof buttonText === 'string'
              ? buttonText
              : translate(lang, 'Confirm')}
          </Button>
        )}
        {type === 'warning' && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='fill'
            color='orange'
            className='ml-16'
            onClick={onConfirm}
            disabled={disabled}
          >
            {typeof buttonText === 'string'
              ? buttonText
              : translate(lang, 'Confirm')}
          </Button>
        )}
        {type === 'delete' && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='fill'
            color='red'
            className='ml-16'
            onClick={onConfirm}
            disabled={disabled}
          >
            {translate(lang, 'Delete')}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default ModalComponent;
